const HOME_ARTICLE_DOCUMENT_ACCEPT = [
    '.jpg',
    '.jpeg',
    '.png',
    '.gif',
    '.webp',
    '.svg',
    '.pdf',
    '.mp4',
    '.webm',
    '.mov',
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'image/svg+xml',
    'application/pdf',
    'video/mp4',
    'video/webm',
    'video/quicktime',
].join(',')

export default HOME_ARTICLE_DOCUMENT_ACCEPT
